import { Reducer } from "redux";

import type IntegrationIssueTracker from "../../../models/api/integration_table_issues";

type LoadedIntegrationIssue = Pick<IntegrationIssueTracker, "id" | "toolName" | "globalId" | "issueId">;

export type IntegrationIssuesStore = {
  issueMap?: Map<string, LoadedIntegrationIssue[]>
}

const initialState: IntegrationIssuesStore = {
  issueMap: new Map()
};
const reduceIntegrationIssues: Reducer<IntegrationIssuesStore> = (
  state = initialState,
  event
) => {
  switch (event.type) {
    case 'SET_ANNOTATION_INTEGRATION_ISSUES':
      let integrationIssues= event.payload;
      // A fetch returns every issue for the global ids it asked about, so it replaces what was loaded for them.
      const fetchedIssueMap = new Map<string, LoadedIntegrationIssue[]>();
      integrationIssues.forEach(issue => {
        const fetchedSoFar = fetchedIssueMap.get(issue.globalId) ?? [];
        fetchedIssueMap.set(issue.globalId, [
          ...fetchedSoFar,
          { id: issue.id, toolName: issue.toolName, globalId: issue.globalId, issueId: issue.issueId }
        ]);
      });
      const issueMap = new Map([...(state.issueMap ?? []), ...fetchedIssueMap]);
      return {
        ...state,
         issueMap
      };
    default:
      return state;
  }

};

export default reduceIntegrationIssues;
